import './Pagination-16a5b4c6.css';

var classes = {"Page":"prc-Pagination-Page-yoEQf","PaginationContainer":"prc-Pagination-PaginationContainer-yNDPO","TablePaginationSteps":"prc-Pagination-TablePaginationSteps-RRjtg"};

export { classes as default };
